import { usePeriodosContables } from "../../../../actions";
import { SelectUi } from "../../../ui";

export const PeriodosContablesSelect = ({ ...others }) => {
  const { data, isLoading } = usePeriodosContables();
  return <SelectUi data={data} loading={isLoading} {...others} />;
};
